import { render, staticRenderFns } from "./payments-icon.vue?vue&type=template&id=3fcc1222"
import script from "./payments-icon.vue?vue&type=script&lang=js"
export * from "./payments-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports